import { Directive, OnDestroy, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * Converts empty string values to null in form controls.
 * Useful for ensuring deleted input values are submitted as null instead of empty strings.
 * 
 * @example
 * <input formControlName="parentId" appNullableString />
 * <kendo-textbox formControlName="name" appNullableString></kendo-textbox>
 */
@Directive({
  selector: '[appNullableString]',
  standalone: true
})
export class NullableStringDirective implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  constructor(private ngControl: NgControl) {
    console.log('NullableStringDirective initialized for:', this.ngControl.name);
  }

  ngOnInit(): void {
    const control = this.ngControl.control;

    console.log('ngOnInit - control:', control);
    console.log('ngOnInit - valueChanges:', control?.valueChanges);

    if (control && control.valueChanges) {
      control.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(value => {
          console.log('Value changed:', value, 'Type:', typeof value);
          if (value === '') {
            console.log('Converting empty string to null');
            control.setValue(null, { emitEvent: false });
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
